import { plainToInstance, Type } from 'class-transformer'

import { Entity } from '@core/entities/entity'
import {
  BriefingSessionParticipant,
  BriefingSessionBriefingPeriod,
} from '@core/entities/briefing'
import { IBriefingSessionData } from './IBriefingSessionData'

export class BriefingSessionData extends Entity<IBriefingSessionData> {
  @Type(() => BriefingSessionParticipant)
  participants: Array<BriefingSessionParticipant>

  briefingPeriods: Array<BriefingSessionBriefingPeriod>

  public static new(payload: unknown): BriefingSessionData {
    const entity = plainToInstance(BriefingSessionData, payload)
    return entity
  }
}
